import { render } from "./minus-icon.vue.js?vue&type=template&id=071545ae!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./minus-icon.vue?vue&type=template&id=071545ae"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__